var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('schedule-container-form',{attrs:{"edit":_vm.edit,"entityType":_vm.entityType,"entityId":_vm.entityId},on:{"added":_vm.backToList,"updated":_vm.backToList,"cancel":_vm.backToList}})}
var staticRenderFns = []

export { render, staticRenderFns }